var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.stage === 'inSale')?_c('div',{staticClass:"shop-now-btn",class:{ selected: _vm.isSelected }},[_vm._v("\n  "+_vm._s(_vm.$t("shopNow"))+"\n")]):_c('div',{staticClass:"shop-now-btn coming-soon"},[_vm._v(_vm._s(_vm.$t("comingSoon")))])
}
var staticRenderFns = []

export { render, staticRenderFns }